export default function CategoryFilter({ categories, active, onChange }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="category-filter">
      <button
        type="button"
        onClick={() => onChange(null)}
        className={`chip ${!active ? "chip-active" : ""}`}
        data-testid="cat-filter-all"
      >
        All
      </button>
      {categories.map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => onChange(c)}
          className={`chip ${active === c ? "chip-active" : ""}`}
          data-testid={`cat-filter-${c}`}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
